import { CircleAlert, CircleCheckBig, Eye } from "lucide-react";
import React, { useState } from "react";
import MyCard4 from "../../../tools/MyCard4";
import MyCard from "../../../tools/MyCard";
import MyCard2 from "../../../tools/MyCard2";
import MyCard3 from "../../../tools/MyCard3";
import { SolidButton } from "../../../global/SolidButton";
import MyCard5 from "../../../tools/MyCard5";

export default function PrivacyPolicy() {
  const [displayName, setDisplayName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [date, setDate] = useState("");
  const [hasPolicy, setHasPolicy] = useState(false);

  function savePolicy() {
    setHasPolicy(true);
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <title>Downloaded HTML</title>
</head>
<body>
  <h1>File generated from React</h1>
</body>
</html>
  `;

    localStorage.setItem("saved_html", htmlContent);
    const blob = new Blob([htmlContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "file.html";
    a.click();

    URL.revokeObjectURL(url);
  }
  return (
    <div className="space-y-2 mt-4">
      {!hasPolicy && (
        <div className="w-full space-x-2   p-4 flex items-center justify-start bg-amber-50 dark:bg-amber-950/20 border-1 border-amber-400/30 rounded-lg">
          <CircleAlert className="w-8 h-8 p-1 text-amber-600 bg-amber-400/20 rounded-md " />
          <div className="flex flex-col justify-center">
            <span className="text-sm text-amber-800 dark:text-amber-400 font-semibold">
              No Deeplink Configuration Set
            </span>
            <span className="text-[12px] text-amber-800 dark:text-amber-400 font-normal ">
              Upload a JSON file below to set up your deeplink configuration.
            </span>
          </div>
        </div>
      )}
      {hasPolicy && (
        <MyCard5
          className=""
          title="Privacy Policy Already Saved"
          subtitle=""
          color="green"
          icon={CircleCheckBig}
        />
      )}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        {hasPolicy && (
          // preview

          <div className="sm:col-span-2 justify-center items-center ">
            {/* top bar */}
            <MyCard>
              <div className="w-full   flex flex-col justify-center border-1 border-gray-500/30 rounded-lg">
                <div className="flex items-center justify-between px-4 py-3 border-gray-500/30 border-b-1 ">
                  <div className="flex items-center space-x-2">
                    {/* icon */}
                    <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                      <Eye className="text-white " />
                    </div>
                    {/* live preview */}
                    <div className="flex flex-col   ">
                      <span className="text-sm font-bold  text-slate-900 dark:text-slate-200">
                        Live Preview
                      </span>
                      <span className="text-[10px] font-normal font-sans dark:text-slate-300 text-slate-900">
                        New File Preview
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`
      bg-white  rounded-lg shadow-md overflow-hidden w-full h-[570px]
    `}
              >
                <iframe
                  //     srcDoc={htmlPreview}
                  className="w-full h-full "
                  title="HTML Preview"
                />
              </div>
            </MyCard>
          </div>
        )}
        <div className="sm:col-span-2">
          <MyCard className="p-4 w-50">
            <form className="flex flex-col" onSubmit={savePolicy}>
              {/* App Name */}
              <label className="text-xs font-sans font-medium  text-slate-900 dark:text-slate-200 tracking-wide">
                App Display Name
              </label>

              {/* Input */}
              <input
                type="text"
                name="appDisplayName"
                value={displayName ?? ""}
                onChange={(e) => setDisplayName(e.target.value.slice(0, 60))}
                placeholder="App Name"
                className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
              />
              <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1.5">
                The name of your application
              </p>
              {/* ------------------------- */}
              {/* Company Name */}
              <label className="text-xs font-sans font-medium mt-6 text-slate-900 dark:text-slate-200 tracking-wide">
                Company Name
              </label>

              {/* Input */}
              <input
                type="text"
                name="companyName"
                value={companyName ?? ""}
                onChange={(e) => setCompanyName(e.target.value.slice(0, 60))}
                placeholder="Your Company Inc."
                className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
              />
              <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1.5">
                Your company's official name
              </p>
              {/* ------------------------- */}
              {/* Contact Email */}
              <label className="text-xs font-sans font-medium mt-6 text-slate-900 dark:text-slate-200 tracking-wide">
                Contact Email
              </label>

              {/* Input */}
              <input
                type="text"
                name="email"
                value={email ?? ""}
                onChange={(e) => setEmail(e.target.value.slice(0, 60))}
                placeholder="contact@company.com"
                className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
              />
              <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1.5">
                Email for privacy concerns
              </p>
              {/* ------------------------- */}
              {/* Company Address */}
              <label className="text-xs font-sans font-medium mt-6 text-slate-900 dark:text-slate-200 tracking-wide">
                Address
              </label>

              {/* Input */}
              <input
                type="text"
                name="address"
                value={address ?? ""}
                onChange={(e) => setAddress(e.target.value.slice(0, 60))}
                placeholder="Company Address"
                className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
              />

              {/* ------------------------- */}
              {/* Effective date */}
              <label className="text-xs font-sans font-medium mt-6 text-slate-900 dark:text-slate-200 tracking-wide">
                Effective Date
              </label>

              {/* Input */}
              <input
                type="date"
                name="effectiveDate"
                value={date ?? ""}
                onChange={(e) => setDate(e.target.value.slice(0, 60))}
                placeholder="Company Address"
                className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
              />
              <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1.5">
                When this policy becomes effective
              </p>
              {/* ------------------------- */}
              <div class="mt-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-900/50 rounded-xl p-2">
                <p class="text-[10px] text-blue-800 dark:text-blue-200 leading-relaxed">
                  <span class="font-semibold block mb-1">💡 Pro Tip:</span>Your
                  privacy policy will be automatically generated and saved to
                  the server when you click "Save".
                </p>
              </div>
              <SolidButton
                type="submit"
                className="mt-4"
                onClick={(e) => {
                  e.preventDefault();
                  savePolicy(e);
                }}
              >
                <span>Save Privacy Policy</span>
              </SolidButton>
            </form>
          </MyCard>
        </div>
      </div>
    </div>
  );
}
